import retailerMapBackground from './retailer-map-background.png'

const retailerBg = {
  retailerMapBackground,
}

export default retailerBg
